// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatWidget {
  --bs-secondary-border-subtle: #eae2da;
}
.ChatWidget .accordion-item:only-child {
  border: 0;
}
.ChatWidget .accordion-item:last-child {
  border-bottom: 0;
}
.ChatWidget .accordion-item {
  border: 0;
  border-bottom: 1px solid var(--bs-secondary-border-subtle);
}

.ChatWidget {
  overflow: hidden;
  position: fixed;
  bottom: 0;
  width: 45vw;
  max-width: 400px;
  right: 50px;
  z-index: 1000;
}
.ChatWidget p {
  margin: 0;
}
.ChatWidget {
  animation: slideIn 0.5s ease;
}
@keyframes slideIn {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.ChatWidget-Unread {
  position: relative;
}
.ChatWidget-Unread .badge {
  position: absolute;
  top: -0.5rem;
  right: -0.5rem;
}
.ChatWidget-Unread .sv-inbox {
  font-size: 24px;
}
.ChatWidget-Unread a {
  color: white;
  text-decoration: none;
}

.ChatWidget-Header {
  color: var(--bs-light);
  background-color: var(--bs-primary);
  letter-spacing: 0.3rem;
}

@media print {
  .ChatWidget {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ChatWidget/styles.scss"],"names":[],"mappings":"AAAA;EAEE,qCAAA;AAAF;AAEE;EACE,SAAA;AAAJ;AAEE;EACE,gBAAA;AAAJ;AAEE;EACE,SAAA;EACA,0DAAA;AAAJ;;AAIA;EACE,gBAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;AADF;AAGE;EACE,SAAA;AADJ;AATA;EAYE,4BAAA;AAAF;AACE;EACE;IACE,2BAAA;EACJ;EACE;IACE,wBAAA;EACJ;AACF;;AAGA;EACE,kBAAA;AAAF;AACE;EACE,kBAAA;EACA,YAAA;EACA,cAAA;AACJ;AACE;EACE,eAAA;AACJ;AACE;EACE,YAAA;EACA,qBAAA;AACJ;;AAGA;EACE,sBAAA;EACA,mCAAA;EACA,sBAAA;AAAF;;AAGA;EACE;IACE,aAAA;EAAF;AACF","sourcesContent":[".ChatWidget {\n  // Variable Overrides\n  --bs-secondary-border-subtle: #eae2da;\n  //bootstrap overrides\n  .accordion-item:only-child {\n    border: 0;\n  }\n  .accordion-item:last-child {\n    border-bottom: 0;\n  }\n  .accordion-item {\n    border: 0;\n    border-bottom: 1px solid var(--bs-secondary-border-subtle);\n  }\n}\n\n.ChatWidget {\n  overflow: hidden;\n  position: fixed;\n  bottom: 0;\n  width: 45vw;\n  max-width: 400px;\n  right: 50px;\n  z-index: 1000;\n\n  p {\n    margin: 0;\n  }\n  animation: slideIn 0.5s ease;\n  @keyframes slideIn {\n    from {\n      transform: translateY(100%);\n    }\n    to {\n      transform: translateY(0);\n    }\n  }\n}\n\n.ChatWidget-Unread {\n  position: relative;\n  .badge {\n    position: absolute;\n    top: -0.5rem;\n    right: -0.5rem;\n  }\n  .sv-inbox {\n    font-size: 24px;\n  }\n  a {\n    color: white;\n    text-decoration: none;\n  }\n}\n\n.ChatWidget-Header {\n  color: var(--bs-light);\n  background-color: var(--bs-primary);\n  letter-spacing: 0.3rem;\n}\n\n@media print {\n  .ChatWidget {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
